import styled from "styled-components";
import { COLORS } from "styles/colors";
import { calcRem } from "styles/theme";
import { FLEX } from "styles/flex";
import * as mediaQuery from "components/MediaQuery";
import { BackgroundImage, commonLoginHeight } from "../SignCommonStyled";

export const BG = styled.div`
  width: 100%;
  min-height: 100dvh;
  background: no-repeat fixed center center;
  background-image: ${BackgroundImage};
  background-size: cover;
  ${FLEX.FlexCenterCenter};
  flex: 1;
`;

export const TitleWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 8px;
  flex-direction: column;

  > .txt {
    color: ${COLORS.WHITE}60;
    margin-bottom: 40px;
  }
`;

export const ResellerSignupWrapper = styled.div`
  width: 100%;
  .title {
    margin-bottom: 5px;
  }
  .email-badge {
    margin-bottom: 30px;
  }
`;

export const SignupTitle = styled.p`
  font-size: ${calcRem(24)};
  font-weight: 500;
  color: white;
  ${FLEX.FlexCenterEnd};
  gap: 8px;
`;

export const SuccessInner = styled.div`
  margin: 0 auto;
  text-align: center;

  > img {
    width: 35%;
  }
  .email-icon-wrapper {
    position: relative;
    display: inline-block;
    vertical-align: top;
    svg {
      display: block;
    }
  }
  .description .email {
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  .checkmark-icon {
    position: absolute;
    bottom: 5px;
    background: ${COLORS.WHITE};
    right: -5px;
    box-shadow: inset 0 0 0 5px ${COLORS.BLACK};
    border-radius: 50%;
  }

  .user-name {
    padding-top: 20px;
  }

  ${mediaQuery.isDefault} {
    .verify-title {
      padding-bottom: 20px;
    }
    .success-box {
      padding: 20px 0 30px;
      white-space: pre-wrap;
      .title,
      .description {
        line-height: 1.25;
      }
    }
  }

  .description {
    line-height: ${calcRem(18)};
  }
  .title {
    margin-bottom: 10px !important;
  }
  ${mediaQuery.isMobile} {
    ${FLEX.FlexBetweenCenter};
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
`;

export const ModalInner = styled.div`
  width: 110%;
  max-height: 80vh;
  overflow-y: auto;
  padding: 10px;
  color: ${COLORS.BUTTONS1};
  font-size: ${calcRem(14)};
  line-height: ${calcRem(18)};

  .button {
    width: 100%;
    text-decoration: underline;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: ${calcRem(14)};
  }
`;

export const EULAText = styled.div`
  width: 100%;
  padding: 20px 0;
  color: ${COLORS.BUTTONS1};
  font-size: ${calcRem(14)};
  line-height: ${calcRem(18)};
  .button {
    width: 100%;
    text-decoration: underline;
    white-space: pre-wrap;
    word-break: break-word;
    font-size: ${calcRem(14)};
  }
  b {
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  th,
  td {
    border: 1px solid ${({ theme }) => theme.COLORS.WHITE};
    padding: 5px;
  }
  th {
    color: ${({ theme }) => theme.COLORS.WHITE};
    vertical-align: middle;
  }
  thead th {
    background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
    font-weight: 600;
  }
  .disc li {
    padding-left: 0;
    list-style-position: inside;
    list-style-type: disc;
    margin-top: 0;
  }
  li {
    margin-top: ${calcRem(20)};
    padding-left: 20px;
    position: relative;
    li:first-child {
      margin-top: 10px;
    }
    ul li {
      padding-left: 0;
    }
    li {
      padding-left: 30px;
    }
    .number {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;
export const AgreementWrapperContainer = styled.div`
  width: 100%;
  > div {
    width: 100%;
  }
`;
export const InputWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  flex-direction: column;
  gap: 20px;
  width: 100%;

  > input {
    color: ${COLORS.BLACK};
    height: ${commonLoginHeight};
    font-size: ${calcRem(14)};
  }
  .free-trial-description {
    text-align: left;
  }
`;
export const AgreementWrapper = styled.label`
  margin-top: 8px;
  ${FLEX.FlexStartCenter};
  gap: 5px;
  font-size: ${calcRem(14)};
  color: ${COLORS.BUTTONS1};
`;

export const SubmitWrapper = styled.div`
  margin-top: 20px;
  button {
    width: 100%;
  }
  label {
    color: ${COLORS.BUTTONS1};
    font-size: ${calcRem(14)};
    margin-bottom: 16px;
  }
  &.free-trial-submit-wrapper {
    margin-top: 30px;
  }
`;

export const PasswordInputInner = styled.div`
  position: relative;
  width: 100%;

  > input {
    color: ${COLORS.BLACK};
    height: ${commonLoginHeight};
    font-size: ${calcRem(14)};
  }
`;

export const PasswordBubble = styled.p`
  position: absolute;
  /* width: 60%; */
  margin-top: 10px;
  z-index: 5;

  ul {
    width: 100%;
    ${FLEX.FlexStartStart};
    flex-direction: column;
    gap: 8px;
    padding: 10px 0;
  }
`;

export const PasswordText = styled.li`
  ${FLEX.FlexCenterCenter};
  gap: 8px;
  font-size: ${calcRem(15)};

  > img {
    width: 15px;
    height: 15px;
  }
`;

export const PasswordTitle = styled.div`
  ${FLEX.FlexCenterCenter};
  gap: 10px;
  padding-bottom: 8px;

  .title {
    margin-bottom: 0 !important;
  }

  ${mediaQuery.isMobile} {
    > img {
      width: 24px;
    }
  }
`;

export const VerifyWrapper = styled.div`
  padding-bottom: 10px;
  width: 80%;
  margin: 0 auto;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
`;

export const TFAWrapper = styled.div`
  width: 100%;
  ${FLEX.FlexBetweenCenter};
  color: ${({ theme }) => theme.COLORS.WHITE};
  font-size: ${calcRem(14)};

  .checkbox-wrapper {
    ${FLEX.FlexEndCenter};
    gap: 20px;
    flex: 1;

    label {
      ${FLEX.FlexStartCenter};
      gap: 6px;
      font-size: ${calcRem(13)};

      > input {
        width: 12px;
        height: 12px;
      }
    }
  }
`;

export const PhoneWrapper = styled.div`
  ${FLEX.FlexBetweenCenter};
  flex-direction: column;
  gap: 8px;
  width: 100%;

  .phone-input-wrapper {
    ${FLEX.FlexBetweenCenter};
    gap: 8px;
    width: 100%;

    input {
      height: 40px;
    }

    > button {
      height: 40px;
      min-width: 100px;

      .icon-button {
        ${FLEX.FlexStartCenter};
        color: ${COLORS.WHITE};
        position: relative;
      }
    }
  }

  .validate-word {
    font-size: ${calcRem(13)};
    padding-top: 0;
    width: 100%;
  }

  #dw_signup_button_forward_signup {
    ${FLEX.FlexEndCenter};
  }
`;

export const ValidWrapper = styled.div`
  width: 100%;
`;

export const SignupInputWrapper = styled.div`
  .common-modal-input {
    padding: 0;
  }
`;

export const FreeTrialContainer = styled.div`
  width: 100%;
  max-width: 400px;
  padding: 30px 45px;
  background-color: ${({ theme }) => theme.COLORS.BACKGROUND};
  border-radius: 8px;
  .mydw-logo,
  .description {
    margin-bottom: 0;
    font-size: ${calcRem(14)};
    line-height: 1.2;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;

export const FreeTrialWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 100%;
  padding: 20px;
`;

export const FreeTrialModal = styled(FreeTrialWrapper)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
`;

export const FreeTrialContent = styled.div`
  background-color: ${({ theme }) => theme.COLORS.WIDGETCOLOR};
  border-radius: 8px;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  gap: 20px;
  width: 100%;
  max-width: 420px;
  padding: 20px 20px 30px;
  font-size: ${calcRem(12)};
  line-height: 1.2;
  color: ${({ theme }) => theme.COLORS.WHITE}95;
  text-align: center;
  h3 {
    padding-top: 30px;
    font-size: ${calcRem(15)};
    font-weight: 600;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  .email {
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
`;
export const FreeTrialModalContent = styled(FreeTrialContent)`
  box-shadow: 0 2px 10px 0 ${({ theme }) => theme.COLORS.WHITE}40;
  h3 {
    font-size: ${calcRem(24)};
  }
`;

export const IconWrapper = styled.div`
  ${FLEX.FlexCenterCenter};
  width: 60px;
  height: 60px;
  background-color: ${({ theme }) => theme.COLORS.BUTTONS1};
  color: ${({ theme }) =>
    theme.value === "light" ? COLORS.WHITE : COLORS.BLACK};
  border-radius: 50%;
  box-shadow: 0 4px 6px 0 ${({ theme }) => theme.COLORS.WHITE}40;
`;

export const InputRow = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 8px;
  width: 100%;
`;

export const BusinessInfoWrapper = styled.div`
  ${FLEX.FlexStartCenter};
  gap: 8px;
  width: 100%;
  flex-direction: column;
  padding-top: 10px;
  color: ${({ theme }) => theme.COLORS.WHITE};
  .select-container div {
    text-align: left;
  }
`;
